import React, { useEffect, useState, useRef } from 'react';
import HeartIcon from '../svg/HeartIcon';
import Favourites from '../../../../components/Favourites';

const FavouritesButton = ({ itemId, toggleFavourite, allFavourites }) => {
	const buttonRef = useRef(null);
	const [isFavourited, setIsFavourited] = useState(((allFavourites || []).map(Number)).includes(parseInt(itemId || 0)));

	useEffect(() => {
		setIsFavourited(((allFavourites || []).map(Number)).includes(parseInt(itemId || 0)));
	}, [itemId]);

	useEffect(() => {
		if (buttonRef.current) {
			new Favourites(buttonRef.current);
		}
	}, []);

	const handleClick = () => {
		// Set favourite state:
		const newFavouriteState = !isFavourited;

		// Set a new 'is favourite':
		setIsFavourited(newFavouriteState);

		// Add favourite to state in Filter component
		toggleFavourite(itemId);

		//console.log( 'handleClick', 'newFavouriteState ' + newFavouriteState, 'itemId ' + itemId );
	};

	return (
		<button
			type="button"
			className={`btn btn--favourite-outline ${isFavourited ? 'active' : ''}`}
			aria-label="Favoriet"
			ref={buttonRef}
			onClick={handleClick}
		>
			<span>{customData.i18n.agenda_favourite}</span>
			<HeartIcon />
		</button>
	);
}

export default FavouritesButton;
